import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant", "as", "responsive", "fontWeight", "inline", "children", "className", "color", "truncate"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as i } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import b from "classnames";
import { useStyleProps as g } from "../../hooks/useStyleProps.js";
import o from "./Typography.module.scss.js";
var P = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    subHeading: "h6",
    body1: "p",
    body2: "p",
    body3: "p"
  },
  $ = function $(_ref, c) {
    var _ref2;
    var _ref$variant = _ref.variant,
      p = _ref$variant === void 0 ? "body1" : _ref$variant,
      t = _ref.as,
      _ref$responsive = _ref.responsive,
      e = _ref$responsive === void 0 ? !0 : _ref$responsive,
      r = _ref.fontWeight,
      y = _ref.inline,
      m = _ref.children,
      n = _ref.className,
      a = _ref.color,
      h = _ref.truncate,
      l = _objectWithoutProperties(_ref, _excluded);
    var d = t || P[p],
      _g = g(l),
      s = _g.styleProps,
      f = _g.componentProps;
    return /* @__PURE__ */i(d, _objectSpread(_objectSpread(_objectSpread({
      className: b([n, (_ref2 = {}, _defineProperty(_ref2, o["typography-".concat(p)], p), _defineProperty(_ref2, o.inline, y), _defineProperty(_ref2, o["".concat(r)], r), _defineProperty(_ref2, o.responsive, e), _ref2), h && o.truncate]),
      ref: c
    }, s), {}, {
      style: _objectSpread(_objectSpread({}, s.style), {}, {
        color: a
      })
    }, f), {}, {
      children: m
    }));
  },
  C = u($);
export { C as default };